angular
    .module('vm')
    .controller('MainController', MainController);

function MainController (RelationshipStatusSelect, $filter, $timeout, $modal, $scope, $http, CursorWait, Notifications, $translate, Auth) {
    var vm = this;
    $scope.vm = vm;

    vm.step = '';
    vm.sendingForm = false;

    vm.username = '';
    vm.password = '';

    vm.setStep = setStep;
    vm.showLoginModal = showLoginModal;
    vm.showUnsubscribeModal = showUnsubscribeModal;
    vm.showForgotPasswordModal = showForgotPasswordModal;
    vm.submitLogin = submitLogin;
    vm.submitForgotPassword = submitForgotPassword;
    vm.facebookLogin = facebookLogin;
    vm.createAccount = createAccount;

    vm.unsubscribedStep = 'now'; // now, already, reminder, resubscribing, resubscribe-error, resubscribed
    vm.unsubscribeParams = {};

    vm.userDefinitionList = RelationshipStatusSelect.getUserDefinitionVM();
    vm.userDefinition = null;

    vm.uResubscribe = function() {
        vm.unsubscribedStep = 'resubscribing';
        var url = '/settings/resubscribe/' + vm.unsubscribeParams['resubscribe_token'];
        CursorWait.enable();
        $http.get(url)
            .then(function () {
                vm.unsubscribedStep = 'resubscribed';
            })
            .catch(function (response) {
                vm.unsubscribedStep = 'resubscribe-error';
            })
            .finally(function () {
                CursorWait.disable();
            })
        ;
    };

    vm.unsubscribeInit = function(params) {
        vm.unsubscribeParams = params;
        if (vm.unsubscribeParams['unsubscribed']) {
            vm.unsubscribedStep = 'now';
        } else
        if (vm.unsubscribeParams['already_unsubscribed']) {
            vm.unsubscribedStep = 'already';
        } else {
            vm.unsubscribedStep = 'reminder';
        }
    };

    activate();

    //////////

    function activate() {

        window.onpopstate = history.onpushstate = function(event) {
            getCurrentStep(event);
        };

        if (window.location.href.match(/\/settings\/unsubscribe\/\w+/)) {
            vm.showUnsubscribeModal();
            return;
        }

        getCurrentStep();
    }
    
    function getCurrentStep() {
        $timeout(function () {
            vm.step = window.location.hash.replace('#/', '');

            if (vm.step === 'login') {
                showLoginModal();
            }
            else if (vm.step === 'forgot-password') {
                showForgotPasswordModal();
            }
        });
    }

    function setStep(step) {
        vm.step = step;
        window.history.pushState('', '', '#/' + step);
    }

    function createAccount(id) {
        console.info('id', id);

        if (id !== undefined) {
            vm.userDefinition = $filter('filter')(vm.userDefinitionList, { id: id })[0];
        }

        vm.setStep('create-account');
    }
    
    function showLoginModal() {
        $modal({
            templateUrl: 'login-modal.html',
            show: true,
            scope: $scope
        });
    }

    function showUnsubscribeModal() {
        $modal({
            templateUrl: 'unsubscribe-modal.component.html',
            show: true,
            scope: $scope
        });
    }

    function showForgotPasswordModal() {
        $modal({
            templateUrl: 'forgot-password-modal.html',
            show: true,
            scope: $scope
        });
    }

    function submitLogin() {
        if (vm.sendingForm) {
            return;
        }

        vm.sendingForm = true;

        CursorWait.enable();

        var data = {
            username: vm.username,
            password: vm.password
        };

        $http.post('/api/v4.0/auth', data)
            .then(function (response) {
                if (response.data.redirectUrl) {
                    window.location.href = response.data.redirectUrl;
                    return;
                }
                Auth.redirectToFrontend(response.data.token);
            })
            .catch(function (response) {
                Notifications.add({
                    text: response.data.error
                });
            })
            .finally(function () {
                CursorWait.disable();
                vm.sendingForm = false;
            })
        ;
    }

    function submitForgotPassword() {
        if (vm.sendingForm) {
            return;
        }

        vm.sendingForm = true;

        CursorWait.enable();

        var data = {
            email: vm.email
        };

        $http.patch('/api/v4.0/account/password_reset', data)
            .then(function () {
                Notifications.add({
                    text: $translate.instant('reset_password.password_reset_sent')
                });
            })
            .catch(function (response) {
                var message = '';

                switch (response.status) {
                    case 404:
                        message = $translate.instant('error.reset_password_account_not_found');
                        break;
                    case 409:
                        message = $translate.instant('error.password_already_requested');
                        break;
                }

                Notifications.add({
                    text: message
                });
            })
            .finally(function () {
                CursorWait.disable();
                vm.sendingForm = false;
            })
        ;
    }

    function facebookLogin() {
        Auth.oAuthLogin('facebook')
            .then(function(response){
                Auth.redirectToFrontend(response.token);
            })
        ;
    }
}